const initialState = {
  eklaimData: null,
  notifySuccessSave: null,
  notifyFailedSave: null,
  errorMessage: null,
  diagnosaResults: null,
  notifySuccessSearchDiagnosa: null,
  notifyFailedSearchDiagnosa: null,
  procedureResults: null,
  notifySuccessSearchProcedures: null,
  notifyFailedSearchProcedures: null
}

const EklaimReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SUCCESS_SAVE_EKLAIM_DATA':
      return {
        ...state,
        notifySuccessSave: true,
        eklaimData: action.eklaimData,
        notifyFailedSave: null,
        errorMessage: null
      }
    case 'FAILED_SAVE_EKLAIM_DATA':
      return {
        ...state,
        notifyFailedSave: true,
        errorMessage: action.errorMessage,
        notifySuccessSave: null
      }
    case 'RESET_NOTIFY_SAVE_EKLAIM':
      return {
        ...state,
        notifySuccessSave: null,
        notifyFailedSave: null,
        errorMessage: null
      }
    case 'SUCCESS_SEARCH_DIAGNOSA':
      return {
        ...state,
        notifySuccessSearchDiagnosa: true,
        diagnosaResults: action.diagnosaResults,
        notifyFailedSearchDiagnosa: null
      }
    case 'FAILED_SEARCH_DIAGNOSA':
      return {
        ...state,
        notifyFailedSearchDiagnosa: true,
        notifySuccessSearchDiagnosa: null
      }
    case 'SUCCESS_SEARCH_PROCEDURES':
      return {
        ...state,
        notifySuccessSearchProcedures: true,
        procedureResults: action.procedureResults,
        notifyFailedSearchProcedures: null
      }
    case 'FAILED_SEARCH_PROCEDURES':
      return {
        ...state,
        notifyFailedSearchProcedures: true,
        notifySuccessSearchProcedures: null
      }
    default:
      return state
  }
}

export default EklaimReducer

